'use strict';

var clsx = require('clsx');
var tailwindMerge = require('tailwind-merge');

function p(...r){return tailwindMerge.twMerge(clsx.clsx(r))}

exports.cn = p;
//# sourceMappingURL=out.js.map
//# sourceMappingURL=index.js.map